import type { ILanguageResources, ITranslationModule } from '../../../interfaces';
import { interpolate } from '../../../global';

class Id {
  private constructor() {}
  public static readonly prefix = 'UI.scripts.dealer-franchisee.projects.ProjectUiAdapter.';
  public static readonly openingProject = `${Id.prefix}openingProject`;
  public static readonly pleaseWaitWhileConstructingProject = `${Id.prefix}pleaseWaitWhileConstructingProject`;
}

export class LangProjectUiAdapter {
  private constructor() {}
  public static openingProject(): string {
    return interpolate(Id.openingProject);
  }
  public static pleaseWaitWhileConstructingProject(): string {
    return interpolate(Id.pleaseWaitWhileConstructingProject);
  }
}

export class ProjectUiAdapterModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(Id.openingProject, "Opening {{glossary 'project'}}", 'Message shown while opening a project');
    register.add(
      Id.pleaseWaitWhileConstructingProject,
      "Please wait while we construct the {{glossary 'project'}}",
      'Message shown while constructing a project'
    );
  }
}
